import React from "react";
import image from "../../Assets/icon/alertIconNew.png";
import {Box} from "@mui/material";

const NotFoundPageImage = () => {
        return (
            <>
                <br/>
                <Box
                    style={{ display: 'table', margin: '0 auto', width: '20%', minWidth: '80px' }}
                    component="img"
                    sx={{

                    }}
                    alt="مشکل در لود عکس"
                    src={image}
                />
                <br/>
            </>
        )
    }

export default NotFoundPageImage
